import { createStore, applyMiddleware } from "redux"
import { composeWithDevTools } from "redux-devtools-extension"
import reducers from "./reducers"

export default function () {
  return createStore(reducers, composeWithDevTools(applyMiddleware()))
}



// WEBPACK FOOTER //
// ./src/store.js